import { CompaniesNav, TeamNav } from '@clearkit/icons';
import classnames from 'classnames';
import {
  CKActionMenu,
  CKBox,
  CKContainerProps,
  CKCountUp,
  CKLayoutGridAuto,
  CKLayoutHorizontal,
  CKPopover,
} from 'clearkit';

import { hideListSmall } from './constants';
import { PaginationButtons } from './PaginationButtons';

type ListHeaderProps = CKContainerProps & {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onNextPage?: () => void;
  onPreviousPage?: () => void;
  pageEnd?: number;
  pageStart?: number;
  previousTotalCompanies?: number;
  previousTotalProspects?: number;
  totalCompanies?: number;
  totalProspects?: number;
};

const Count = ({
  children,
  end,
  label,
  start,
}: CKContainerProps & {
  end: number;
  label: string;
  start: number;
}) => (
  <CKLayoutHorizontal
    className="min-w-0 text-sm"
    gap="0.5rem"
    justifyContent="start"
  >
    {children}
    <span>
      <CKCountUp duration={1000} end={end} start={start} />{' '}
      <span className={hideListSmall}>{label}</span>
    </span>
  </CKLayoutHorizontal>
);

const ActionMenu = (
  <CKActionMenu>
    <CKActionMenu.Item>Display all</CKActionMenu.Item>
    <CKActionMenu.Item>Display only selected</CKActionMenu.Item>
  </CKActionMenu>
);

export const ListHeader = ({
  className,
  totalProspects = 0,
  totalCompanies = 0,
  pageStart,
  pageEnd,
  previousTotalCompanies = 0,
  previousTotalProspects = 0,
  onNextPage,
  onPreviousPage,
  hasNextPage,
  hasPreviousPage,
}: ListHeaderProps) => {
  return (
    <CKBox
      className={classnames(
        className,
        'px-6 py-4 !bg-white/40 backdrop-blur-lg sticky top-8 z-10',
      )}
    >
      <CKLayoutHorizontal className="@item/list:flex-nowrap">
        <CKLayoutGridAuto
          autoRepeat="auto-fit"
          className="min-w-0 grow-1 basis-full max-w-[26rem]"
          minWidth="9rem"
        >
          <Count
            end={totalCompanies}
            label="companies"
            start={previousTotalCompanies}
          >
            <CompaniesNav height={18} width={18} />
          </Count>
          <Count
            end={totalProspects}
            label="prospects"
            start={previousTotalProspects}
          >
            <TeamNav height={18} width={18} />
          </Count>
        </CKLayoutGridAuto>
        <CKLayoutHorizontal
          className="shrink-0 basis-auto"
          justifyContent="end"
        >
          <CKPopover popover={ActionMenu} wrapperClassName="relative">
            <CKPopover.Trigger
              className="!text-sm"
              variant="tertiary"
              variantColor="blue"
            >
              <span className={hideListSmall}>Displaying</span> {pageStart} -{' '}
              {pageEnd}
            </CKPopover.Trigger>
          </CKPopover>
          <PaginationButtons
            hasNextPage={hasNextPage}
            hasPreviousPage={hasPreviousPage}
            onNextPage={onNextPage}
            onPreviousPage={onPreviousPage}
          />
        </CKLayoutHorizontal>
      </CKLayoutHorizontal>
    </CKBox>
  );
};
